/** @format */

import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TrainingDashboard from "./training-dashboard";
import LisTrainingVsActual from "./list-training-vs-actual";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

const QualityApproverPendingRequests = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            marginTop: "10px",
            minHeight: "32px",
            "& .MuiTab-root": {
              minHeight: "32px",
              fontSize: "12px",
              padding: "4px 8px",
            },
            "& .MuiTabs-indicator": {
              height: "2px",
            },
          }}
        >
          <Tab label="Training VS Actual Dashboard" />
          <Tab label="Create Training VS Actual Report" />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <TrainingDashboard />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <LisTrainingVsActual />
      </TabPanel>
    </Box>
  );
};

export default QualityApproverPendingRequests;
